import type { InstanceApi } from '@eis/insuranceservice-sdk';

/**
 * The lead vocabulary as the wire spells it (SDD-013), re-exported under the feature's own names
 * so the screens of prompt 19 phase 6 import one module and never the SDK directly.
 */
export type Lead = InstanceApi.Lead;
export type LeadStatus = InstanceApi.LeadStatus;
export type LeadStatusKind = NonNullable<LeadStatus['kind']>;
export type AvailableTransition = InstanceApi.AvailableTransition;
export type LeadVersion = InstanceApi.LeadVersion;
export type PartnerDraft = InstanceApi.PartnerDraft;
export type LeadImportJob = InstanceApi.LeadImportJob;
export type LeadImportItem = InstanceApi.LeadImportItem;
export type AvailableTarif = InstanceApi.AvailableTarif;

/**
 * The lead reason codes (fixtures/golden/leads/conflict-reasons.json, `pkg/svccontract`): what a
 * 409 carries and what a screen switches on. Partner portals build UX on the code, not the text.
 */
export const LEAD_REASONS = {
  locked: 'LEAD_LOCKED',
  notAccepted: 'LEAD_NOT_ACCEPTED',
  alreadyConverted: 'LEAD_ALREADY_CONVERTED',
  pinStale: 'LEAD_PIN_STALE',
  expired: 'LEAD_EXPIRED',
  transitionNotAllowed: 'TRANSITION_NOT_ALLOWED',
  transitionRequiresApprove: 'TRANSITION_REQUIRES_APPROVE',
  transitionReasonRequired: 'TRANSITION_REASON_REQUIRED',
  fourEyes: 'FOUR_EYES',
  partnerDraftInvalid: 'PARTNER_DRAFT_INVALID',
  partnerRoleDuplicate: 'PARTNER_ROLE_DUPLICATE',
  partnerRegistryUnavailable: 'PARTNER_REGISTRY_UNAVAILABLE',
} as const;

export type LeadReason = (typeof LEAD_REASONS)[keyof typeof LEAD_REASONS];
